import { getAdminMembers, SaveData } from '@/actions';
import React, { useCallback } from 'react';
import List from './List';
import { useNotify } from 'react-admin';
import { usePagination } from '@/hooks/usePagination';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import IconButton from '@/ctComponents/IconButton';
import { UserRoundPlus } from 'lucide-react';

export default () => {
  const [form, setForm] = React.useState(null);
  const [filter, setFilter] = React.useState({
    open: false,
    appliedFilters: {},
  });
  const notify = useNotify();

  const dynamicPageSize = useCallback(() => {
    const pageContainer = document.getElementById('page-container-ab');
    if (!pageContainer) {
      return;
    }

    const whiteSpace = pageContainer.getBoundingClientRect().height - 132;
    let calculatedSize = null;

    if (whiteSpace > 0) {
      calculatedSize = Math.floor((whiteSpace - 200) / 53);
      calculatedSize = Math.max(5, Math.min(100, calculatedSize));
    }

    return calculatedSize;
  }, []);

  const fetchApi = useCallback(
    (page) => {
      if (dynamicPageSize() === null) {
        return Promise.resolve({
          data: [],
          total: 0,
          per_page: 10,
          last_page: 1,
        });
      }

      const params = {
        page,
        per_page: dynamicPageSize(),
      };

      if (form) {
        Object.assign(params, form);
      }

      if (filter.appliedFilters?.search) {
        params.s = filter.appliedFilters.search;
      }

      return getAdminMembers(params);
    },
    [form, filter.appliedFilters, dynamicPageSize]
  );

  const handleResponse = useCallback((response) => {
    return response.data || [];
  }, []);

  const {
    items: DATATable,
    loading: loadingData,
    refetch,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPageChange,
  } = usePagination(fetchApi, {
    deps: [form, filter.appliedFilters, dynamicPageSize],
    handleResponse,
  });

  const refetchWithPagePreservation = useCallback(() => {
    refetch({ preservePage: true, targetPage: currentPage });
  }, [refetch, currentPage]);

  return (
    <PageContainerAB
      minWidth={'unset'}
      title="Members"
      mainPage
      rightContent={
        <IconButton
          text="Add New Member"
          icon={<UserRoundPlus />}
          onClick={() => {
            SaveData({ addMemberPopup: true });
          }}
          color="#fff"
          style={{
            backgroundColor: '#131517',
            height: '40px',
          }}
        />
      }>
      <List
        filter={filter}
        setFilter={setFilter}
        setFilterForm={setForm}
        getMembers={refetchWithPagePreservation}
        DATA={DATATable || []}
        notify={notify}
        loading={loadingData}
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
      />
    </PageContainerAB>
  );
};
